import { FORM_CODES } from 'insurers/irishLife'
import * as reports from './reports'

export default () => {

    const getReportByCode = (formCode) => {

        // Get object containing the reports for the form code specified
        const report = ({
            [FORM_CODES.pmar]: reports.Pmar,
            [FORM_CODES.mir]: reports.MissingInformation,
            [FORM_CODES.tumour]: reports.Tumour,
            [FORM_CODES.mentalHealth]: reports.MentalHealth,
            [FORM_CODES.stroke]: reports.Stroke,
            [FORM_CODES.multipleSclerosis]: reports.MultipleSclerosis,
            [FORM_CODES.sarcoidosis]: reports.Sarcoidosis,
            [FORM_CODES.heartDisease]: reports.HeartDisease,
            [FORM_CODES.hepatitis]: reports.Hepatitis,
            [FORM_CODES.kidney]: reports.Kidney,
            [FORM_CODES.respiratory]: reports.Respiratory,
            [FORM_CODES.diabetes]: reports.Diabetes
        })[formCode]

        return report
    }

    return {
        getReportByCode
    }
}